import React from 'react';

const TabFormValidationBadge = ({isFormComplete}) => (

    <span className='tab-form-validation-badge' style={{display: isFormComplete ? 'none' : 'inline'}}>
        <svg width='10' height='10'>
            <circle cx='3' cy='3' r='3' fill='#d82943' />
        </svg>
    </span>
);

export default TabFormValidationBadge;


// WEBPACK FOOTER //
// ./src/components/portal/tabFormValidationBadge.jsx